{
  "ui": {
    "feedback": "Povratne informacije",
    "credits": "Zasluge",
    "currentMaintainer": "Trenutačno održavanje",
    "maintainerPeriod": "Od 2026. nadalje",
    "originalTeam": "Izvorni tim",
    "creditsCampaigns": "Džungla i Božić",
    "moreSettings": "Dodatne postavke",
    "chooseLanguage": "Odaberi jezik",
    "notebookTools": "Alati bilježnice",
    "visualGuide": "Slikovni vodič",
    "templeSoon": "Uskoro",
    "playAdventure": "Igraj",
    "story": "Priča",
    "loadingAdventure": "Spremamo se za pustolovinu…",
    "storyOpening": "Školski izlet u džunglu. Marco i Sophia istražuju s prijateljima. Šarena ptica privuče Marcovu pozornost pa je slijedi među drveće. Odjednom ostaje sam. Pomogni istraživačima pronaći put!",
    "storyEnding": "Marco i Sophia zajedno stižu do izgubljenog hrama. Tajanstveno lice čuva ulaz. Čeka ih nova pustolovina!",
    "blockCategories": "Kartice bilježnice",
    "actions": "Radnje",
    "loops": "Petlje",
    "conditions": "Uvjeti",
    "title": "Run Marco! — Pustolovina u tvojoj bilježnici",
    "home": "Početna stranica Run Marco",
    "map": "Karta pustolovine",
    "worlds": "Odaberi pustolovinu",
    "notebook": "Moja bilježnica",
    "notebookToggle": "Otvori ili zatvori bilježnicu",
    "notebookOpen": "Otvori bilježnicu",
    "notebookClose": "Promatraj stazu",
    "page": "Stranica {number}",
    "level": "Staza {number}",
    "run": "Krenimo!",
    "stop": "Zaustavi",
    "step": "Jedan korak",
    "stepTitle": "Izvrši jednu naredbu",
    "reset": "Natrag na početak",
    "add": "Dodaj",
    "addLabel": "Odaberi blok za dodavanje",
    "addHint": "Spoji blokove pa pritisni Igraj.",
    "undo": "Poništi",
    "clear": "Nova stranica",
    "hint": "Mali savjet",
    "help": "Kako igrati",
    "settings": "Postavke",
    "language": "Jezik igre",
    "blockLanguage": "Jezik blokova",
    "blockLanguageNote": "Za blokove možeš odabrati drugi jezik.",
    "musicOn": "Uključi zvuk",
    "musicOff": "Isključi zvuk",
    "sound": "Glazba i zvučni efekti",
    "speed": "Brzina pustolovine",
    "chooseExplorer": "Odaberi istraživača",
    "explorer": "Istraživač",
    "marco": "Marco",
    "sophia": "Sophia",
    "close": "Zatvori",
    "done": "Istražujmo!",
    "loading": "Tražimo stazu…",
    "loadError": "Pustolovina se nije mogla učitati. Ponovno učitaj stranicu i pokušaj opet.",
    "imageError": "Neke se slike nisu mogle učitati. Ponovno učitaj stranicu.",
    "gemGoal": "Pronađi dragulj",
    "goal": "Pronađi zlatnu zvijezdu",
    "cover": "Osvijetli svako polje samo jednom",
    "lit": "Osvijetljena polja: {count} / {total}",
    "explored": "Istražene staze: {count} / {total}",
    "facing": "Gleda {direction} {arrow}",
    "boardLabel": "{name} na stazi {level}, gleda {direction}. {steps}. {objective}.",
    "up": "gore",
    "down": "dolje",
    "left": "lijevo",
    "right": "desno",
    "steps_one": "{count} korak",
    "steps_other": "{count} koraka",
    "blocks_one": "{count} blok",
    "blocks_other": "{count} blokova",
    "stars_one": "{count} zvijezda",
    "stars_other": "{count} zvijezda",
    "place": "Dodaj blokove",
    "atEnd": "Na kraj",
    "insideRepeat": "Unutar ponavljanja {number}",
    "insideIf": "Unutar ako {number}",
    "insideElse": "Unutar inače {number}",
    "readyFirst": "Jedan mali korak. Dodaj blok naprijed i krenimo!",
    "ready": "Kamo idemo? Složi plan u bilježnici.",
    "back": "Opet na početku. Blokovi su spremni za novi pokušaj.",
    "empty": "Najprije dodaj blok u bilježnicu.",
    "win": "Put je pronađen!",
    "winCover": "Cijela staza svijetli!",
    "winDetails": "{steps} · {blocks}",
    "brilliant": "Kakva pustolovina!",
    "simpler": "Možeš li upotrijebiti manje blokova?",
    "complete": "Staza završena! Tvoje najbolje zvijezde su spremljene.",
    "next": "Sljedeća staza",
    "allWorlds": "Još pustolovina",
    "replay": "Igraj ponovno",
    "shortGoal": "Skoro! Dodaj još blokova da stigneš do zvijezde.",
    "shortGem": "Skoro! Dodaj još blokova da stigneš do dragulja.",
    "shortCover": "Neka su polja još tamna. Kako doći do njih?",
    "checking": "Promatramo stazu…",
    "paused": "Zaustavljeno. Igraj počinje opet od početka.",
    "going": "Na put!",
    "stepped": "Korak bliže. Pritisni Jedan korak ili Igraj za nastavak.",
    "clueCover": "Kreni od ruba i obiđi cijeli oblik. Skokom možeš preskočiti polje bez osvjetljavanja.",
    "clueCondition": "Pogledaj stazu ispred sebe. Uvjet pomaže istraživaču odabrati što učiniti.",
    "clueRepeat": "Koji se koraci ponavljaju? Stavi taj uzorak u blok ponavljanja.",
    "clueForward": "Naprijed prati smjer istraživačeva pogleda. Prebroji polja do zvijezde.",
    "clueGem": "Naprijed prati smjer istraživačeva pogleda. Prebroji polja do dragulja.",
    "clueTurn": "Okret mijenja smjer bez pomicanja. Prati stazu prstom.",
    "mapNote": "Odaberi stazu. Tvoje najbolje zvijezde ostaju spremljene.",
    "mapLevel": "Staza {number}: {name}. {stars}.",
    "locked": "Završi prethodnu stazu da otključaš ovu.",
    "soundBlocked": "Dodirni gumb zvuka da čuješ pustolovinu.",
    "clearTitle": "Otvoriti novu stranicu?",
    "clearNote": "Blokovi ove staze bit će obrisani. Poništi ih može vratiti.",
    "keep": "Zadrži moje blokove",
    "clearConfirm": "Obriši blokove",
    "fresh": "Nova stranica. Kamo će nas odvesti tvoj sljedeći plan?",
    "localProgress": "Tvoj se napredak sprema na ovom uređaju.",
    "helpBuild": "Složi plan",
    "helpBuildText": "Povuci blokove u bilježnicu i spoji ih ili dodirni blok za dodavanje. Odaberi „Unutar ponavljanja” za dodavanje koraka u petlju.",
    "helpTurn": "Prati istraživača",
    "helpTurnText": "Naprijed prati pogled. Lijevo i desno okreću na mjestu. Skok prelazi dva polja.",
    "helpTry": "Pokušaj, promatraj i pokušaj opet",
    "helpTryText": "Pritisni Igraj za plan ili Jedan korak za jednu naredbu. Zakrivljena strelica vraća na početak i čuva blokove.",
    "helpWorlds": "Svaka pustolovina ima cilj",
    "helpWorldsText": "U Džungli pronađi dragulj. U božićnoj pustolovini osvijetli svako slobodno polje jednom. U Hramu i Egejskom moru dovrši popravke i vidljive ciljeve pa stigni do izlaza.",
    "noTrail": "Tamo nema staze! Pokušaj se najprije okrenuti.",
    "broken": "Taj most je slomljen. Možeš li ga preskočiti?",
    "blocked": "Nešto blokira put. Pokušaj skok ili drugi put.",
    "alreadyLit": "To polje već svijetli. Posjeti svako polje samo jednom.",
    "loopError": "Ovaj se plan stalno ponavlja. Pokušaj promijeniti petlju.",
    "repeatError": "Odaberi broj ponavljanja od 1 do 99.",
    "unsupported": "Ukloni nepodržani blok i pokušaj ponovno.",
    "connect": "Spoji blokove u jedan lanac pa pritisni Igraj.",
    "path": "staza",
    "steps_few": "{count} koraka",
    "blocks_few": "{count} bloka",
    "stars_few": "{count} zvijezde",
    "backpack": "Ruksak",
    "templeGems": "Dragulji hrama",
    "gemsCollected": "Dragulji: {count} / {total}",
    "gemsReady": "Svi su dragulji prikupljeni!",
    "aegeanTitle": "Tajne Egejskog mora",
    "harbour": "Luka",
    "aegeanDescription": "Istraži luku: popravljaj postaje, ponovno upotrebljavaj potprograme i uz svaki nalog pošalji broj.",
    "templeBetaNote": "Beta · Zagonetke i lekcije se dorađuju",
    "aegeanBetaNote": "Beta · Prve 3 razine u luci",
    "seasonal": "Sezonska pustolovina",
    "choosePreview": "Odaberi oglednu razinu",
    "repairs": "Popravci",
    "reachExit": "Stigni do izlaza",
    "taskRequirements": "Ciljevi zadatka",
    "lessonGuided": "Vođena vježba · dopuni pripremljeni program",
    "lessonRepair": "Otklanjanje pogrešaka · popravi pripremljeni program",
    "lessonChallenge": "Izazov · izradi vlastiti program",
    "acc_define_parameter": "Potprogram",
    "acc_call_argument": "Pozovi potprogram",
    "acc_repeat_parameter": "Ponavljaj prema ulazu",
    "parameter": "parametar",
    "argument": "pošalji",
    "callInput": "Ulaz ovog poziva",
    "inputWaiting": "Pokreni program ili izvrši jednu naredbu da vidiš sljedeći ulaz.",
    "argumentMismatch": "Potprogram s parametrom treba poziv s brojem. Bez parametra upotrijebi običan poziv.",
    "unsetParameter": "Parametar upotrebljavaj samo unutar potprograma koji ga prima. Parametri su odvojeni od zajedničke memorije.",
    "memoryObjective": "Provjeri zapis popravaka i uvjete izlaza. Prihvaća se svaki program koji ih ispunjava.",
    "gate": "Put je blokiran. Provjeri nedovršene popravke.",
    "noPickup": "Stani na alat prije nego što ga pokupiš.",
    "creditLead": "Vođenje tima i razvoj softvera",
    "creditArt": "Ilustracije i scenografija",
    "creditAnimation": "Animacija",
    "creditUX": "Dizajn sučelja i korisničkog iskustva",
    "creditDesign": "Dizajn igre",
    "creditStory": "Pisanje priče",
    "creditAudio": "Glazba i tonska tehnika",
    "lightLamp": "Upali svjetiljku",
    "oilLamp": "Uljna svjetiljka",
    "dustyStation": "prašnjava postaja",
    "betaLabel": "Beta",
    "noLamp": "Stani na ugašenu svjetiljku prije nego što je upališ.",
    "collected": "Alat preuzet · spreman za upotrebu",
    "dustyPrompt": "Stani na prašnjavu postaju prije upotrebe kista.",
    "lampMissing": "Prvo uzmi uljnu svjetiljku. Pogledaj u ruksak.",
    "recursiveRoutine": "Ovaj potprogram poziva sam sebe. Upotrijebi drugi potprogram; rekurzivni pozivi još nisu dostupni."
  },
  "content": {
    "jungle.title": "Ekspedicija u džunglu",
    "jungle.description": "Prati stazu do izgubljenog hrama.",
    "jungle-1": "Prvi koraci",
    "jungle-2": "Malo dalje",
    "jungle-3": "Iza ugla",
    "jungle-4": "Promijeni smjer",
    "jungle-5": "Prati stazu",
    "jungle-6": "Novi put",
    "jungle-7": "Nove staze",
    "jungle-8": "Raskrižje u džungli",
    "jungle-9": "Pronađi put",
    "jungle-10": "Misli unaprijed",
    "jungle-11": "Duga staza",
    "jungle-12": "Zavojit put",
    "jungle-13": "Hrabar skok",
    "jungle-14": "Pojavljuju se uzorci",
    "jungle-15": "Ponovi ritam",
    "jungle-16": "Odaberi stazu",
    "jungle-17": "Pogledaj prije skoka",
    "jungle-18": "Čitaj stazu",
    "jungle-19": "Pametan obilazak",
    "jungle-20": "Pod krošnjama",
    "jungle-21": "Graditelj mostova",
    "jungle-22": "S druge strane rijeke",
    "jungle-23": "Istraži ruševine",
    "jungle-24": "Kamen i drvo",
    "jungle-25": "Veći skok",
    "jungle-26": "Prati tragove",
    "jungle-27": "Na viši teren",
    "jungle-28": "Nastavi istraživati",
    "jungle-29": "Vijugave staze",
    "jungle-30": "Tajni vrt",
    "jungle-31": "Skriveni uzorci",
    "jungle-32": "Drevne staze",
    "jungle-33": "Posljednji zavoji",
    "jungle-34": "Prema hramu",
    "jungle-35": "Skoro smo stigli",
    "jungle-36": "Izgubljeni hram",
    "winter.title": "Zimska staza",
    "winter.description": "Osvijetli svaki otisak stopala.",
    "winter-1": "Koraci u snijegu",
    "winter-2": "Drugi smjer",
    "winter-3": "Smrznuti kutovi",
    "winter-4": "Dugi obilazak",
    "winter-5": "Pahuljica",
    "winter-6": "Zimske petlje",
    "winter-7": "Istraživač leda",
    "winter-8": "Zavoji i okreti",
    "winter-9": "Ledena logika",
    "winter-10": "Tragač za uzorcima",
    "winter-11": "Majstor staze",
    "winter-12": "Zimsko čudo",
    "temple.title": "Izgubljeni hram",
    "temple.description": "Četrdeset povezanih soba. Obnovi nebeski uređaj alatima, memorijom i vlastitim potprogramima."
  },
  "blockly": {
    "ARIA_LABEL_TRASH_EMPTY": "Koš je prazan",
    "OPEN_TRASH": "Otvori koš",
    "BLOCK_LABEL_BEGIN_STACK": "Početak niza",
    "WORKSPACE_LABEL_1_STACK": "1 niz blokova",
    "WORKSPACE_LABEL_MANY_STACKS": "Nizovi blokova: %1",
    "ARIA_TYPE_FIELD_NUMBER": "broj",
    "ARIA_TYPE_FIELD_DROPDOWN": "padajući popis",
    "ARIA_TYPE_FIELD_IMAGE": "slika",
    "WORKSPACE_LABEL_PLAIN": "Moja bilježnica",
    "FIELD_LABEL_EDIT_PREFIX": "Uredi %1",
    "BLOCK_LABEL_HAS_INPUT": "ima ulaz",
    "BLOCK_LABEL_HAS_INPUTS": "ima ulaze",
    "BLOCK_LABEL_HAS_BRANCHES": "grane: %1",
    "FIELD_LABEL_OPTION_INDEX": "Mogućnost %1",
    "INPUT_LABEL_EMPTY": "Prazno",
    "BLOCK_LABEL_DISABLED": "onemogućeno",
    "BLOCK_LABEL_COLLAPSED": "sažeto",
    "BLOCK_LABEL_BEGIN_PREFIX": "Početak: %1",
    "INPUT_LABEL_END_STATEMENT": "Kraj: %1",
    "ARIA_TYPE_FIELD_TEXT_INPUT": "tekst",
    "ARIA_TYPE_FIELD_INPUT": "ulaz",
    "ARIA_TYPE_FIELD_TEXT_INPUT_ARGUMENT": "naziv ulaza",
    "ARIA_TYPE_FIELD_TEXT_INPUT_PROCEDURE": "naziv potprograma"
  }
}
